import React from 'react'
// import { Link } from 'react-router-dom'

// import ImgDefault from '../../assets/default-thumbnail.jpg'
// import Button from '../partials/Button'
import '../../styles/Film.css'
// const img_base_url = '/images/films/'
const Film = ({ films }) => {
  // const [currentVideo, setCurrentVideo] = useState(films[0])
  return (
    <div className='multi-film-display-wrapper'>
      {/* <p className='multi-film-description sans'>
        {currentVideo.description}
      </p> */}
      {/* <div className='single-film-container'>
        <iframe
          title='title'
          src={`${currentVideo.url}&title=0&byline=0&portrait=0`}
          frameborder='0'
          allow='autoplay; fullscreen; picture-in-picture'
          allowfullscreen
        ></iframe>
      </div> */}

      {/* <div className='multi-film-selector'>
        {films.map((item) => {     
          const img = item.img ? img_base_url + item.img : ImgDefault
          return (
            <div key={item.id} 
              className={currentVideo.id === item.id ? 'active' : ''}
              onClick={() => setCurrentVideo(item)}
            >
              <img src={img} alt="" />
            </div>
          )
        })}
      </div> */}
      <div className='multi-film-display caption serif-bold'>
      {films.map((item, index) => {
        if (index % 2 === 0) {
          // Pair current item with the next one to display them side by side with same heights
          const nextItem = films[index + 1];
          const description = item.description ? item.description : ''
          const nextDescription = nextItem && nextItem.description ? nextItem.description : ''
          const url = item.url ? item.url : ''
          const nextUrl = nextItem && nextItem.url ? nextItem.url : ''
          return (
            <div className='filmGroup' key={index}>
              <div className='description' >{description}</div>
              <div className='description'  >{nextDescription}</div>
              <iframe
                  title='title'
                  src={`${url}&title=0&byline=0&portrait=0`}
                  frameBorder='0'
                  allow='autoplay; fullscreen; picture-in-picture'
                  allowFullScreen
                ></iframe>
                {nextItem && <iframe 
                  title='title'
                  src={`${nextUrl}&title=0&byline=0&portrait=0`}
                  frameBorder='0'
                  allow='autoplay; fullscreen; picture-in-picture'
                  allowFullScreen
                ></iframe>}
            </div>
          );
        }
        return null; // Skip the odd indexes since they are already handled
      })}
      
        
      

      {/* <div className='single-film-btns'>
      <Link to='/availability'>
        <Button
          inverted
          name='View Availability'
          className='button sans-light-bold'
        />
      </Link>
      <Link to='/contact'>
        <Button
          inverted
          name='Schedule Tour'
          className='button sans-light-bold'
          onClick={this.onViewFloorplanClick}
        />
      </Link>
    </div> */}
    </div>
    </div>
  )
}

export default Film



// WEBPACK FOOTER //
// ./src/components/pages/Films.js